<div class="unsupported-container">
    <div class="unsupported-content"
        [ngClass]="{'unsupported-content-small': !urlAimed, 'unsupported-content-medium': urlAimed}">
        <div class="smash-logo">
            <i class="icon-smash_icologo_chip"></i>
        </div>
        <div class="unsupported-message">
            <ng-container *ngIf="urlAimed; else noUrlAimed">
                <h1 *ngIf="browserLanguage === 'fr'">
                    Oups!
                </h1>
                <h1 *ngIf="browserLanguage === 'en'">
                    Oops!
                </h1>
                <h1 *ngIf="browserLanguage === 'de'">
                    Upps!
                </h1>
                <h1 *ngIf="browserLanguage === 'es'">
                    ¡Vaya!
                </h1>
                <h1 *ngIf="browserLanguage === 'it'">
                    Oops!
                </h1>
                <h1 *ngIf="browserLanguage === 'pt'">
                    Ups!
                </h1>
                <p *ngIf="browserLanguage === 'fr'">
                    Smash ne fonctionne pas avec ce navigateur. Pour télécharger les fichiers, merci de copier le lien
                    ci-dessous et de le coller dans un autre navigateur.
                </p>
                <p *ngIf="browserLanguage === 'en'">
                    Smash isn't working on this browser. To download the files, please copy the link below and paste it into
                    another browser.
                </p>
                <p *ngIf="browserLanguage === 'de'">
                    Smash isn't working on this browser. To download the files, please copy the link below and paste it into
                    another browser.
                </p>
                <p *ngIf="browserLanguage === 'es'">
                    Smash no funciona en este navegador. Para descargar los archivos, copie el siguiente enlace y péguelo en
                    otro navegador.
                </p>
                <p *ngIf="browserLanguage === 'it'">
                    Smash isn't working on this browser. To download the files, please copy the link below and paste it into
                    another browser.
                </p>
                <p *ngIf="browserLanguage === 'pt'">
                    Smash isn't working on this browser. To download the files, please copy the link below and paste it into
                    another browser.
                </p>
                <div class="url" (click)="copyLink(urlAimed)">
                    <p>{{ urlAimed }}</p>
                    <div class="upload-button-copy-link-copied" [ngClass]="{'hide-opacity': fadeOut}" *ngIf="linkCopied">
                        <span *ngIf="browserLanguage === 'fr'">Lien copié.</span>
                        <span *ngIf="browserLanguage === 'en'">Link copied.</span>
                        <span *ngIf="browserLanguage === 'de'">Link kopiert.</span>
                        <span *ngIf="browserLanguage === 'es'">Enlace copiado.</span>
                        <span *ngIf="browserLanguage === 'it'">Link copiato.</span>
                        <span *ngIf="browserLanguage === 'pt'">O link foi copiado.</span>
                    </div>
                </div>
                <button (click)="copyLink(urlAimed)" class="btn red button-copy" *ngIf="browserLanguage === 'fr'">Copier le
                    lien</button>
                <button (click)="copyLink(urlAimed)" class="btn red button-copy" *ngIf="browserLanguage === 'en'">Copy
                    link</button>
                <button (click)="copyLink(urlAimed)" class="btn red button-copy" *ngIf="browserLanguage === 'de'">Link
                    kopieren</button>
                <button (click)="copyLink(urlAimed)" class="btn red button-copy" *ngIf="browserLanguage === 'es'">Copiar
                    enlace</button>
                <button (click)="copyLink(urlAimed)" class="btn red button-copy" *ngIf="browserLanguage === 'it'">Copia
                    link</button>
                <button (click)="copyLink(urlAimed)" class="btn red button-copy" *ngIf="browserLanguage === 'pt'">Copiar
                    link</button>
            </ng-container>
            <ng-template #noUrlAimed>
                <h1 *ngIf="browserLanguage === 'fr'">
                    Oups!
                </h1>
                <h1 *ngIf="browserLanguage === 'en'">
                    Oops!
                </h1>
                <h1 *ngIf="browserLanguage === 'de'">
                    Upps!
                </h1>
                <h1 *ngIf="browserLanguage === 'es'">
                    ¡Vaya!
                </h1>
                <h1 *ngIf="browserLanguage === 'it'">
                    Oops!
                </h1>
                <h1 *ngIf="browserLanguage === 'pt'">
                    Ups!
                </h1>
                <p *ngIf="browserLanguage === 'fr'">
                    Smash ne fonctionne pas avec ce navigateur. Nos fonctionnalités sont au rendez-vous sur tous les autres
                    navigateurs... nous avons hâte de vous y retrouver !
                </p>
                <p *ngIf="browserLanguage === 'en'">
                    Smash isn't working on this browser. Our features are on all the others browsers... We're excited to see
                    you there!
                </p>
                <p *ngIf="browserLanguage === 'de'">
                    Smash isn't working on this browser. Our features are on all the others browsers... We're excited to see
                    you there!
                </p>
                <p *ngIf="browserLanguage === 'es'">
                    Smash no funciona en este navegador. Nuestras funciones están en todos los otros navegadores...Tenemos
                    ganas de verte por ahí!
                </p>
                <p *ngIf="browserLanguage === 'it'">
                    Smash isn't working on this browser. Our features are on all the others browsers... We're excited to see
                    you there!
                </p>
                <p *ngIf="browserLanguage === 'pt'">
                    Smash isn't working on this browser. Our features are on all the others browsers... We're excited to see
                    you there!
                </p>
            </ng-template>
        </div>
    </div>
</div>